import { forwardRef } from 'react'
import { X, ChevronDown } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { UserSelectItem } from '@/api/users'

interface UserSelectTriggerProps {
  selected: UserSelectItem[]
  placeholder?: string
  disabled?: boolean
  multiple?: boolean
  onRemove?: (userId: number) => void
  onClick?: () => void
}

export const UserSelectTrigger = forwardRef<HTMLButtonElement, UserSelectTriggerProps>(
  function UserSelectTrigger(
    {
      selected,
      placeholder = '请选择用户',
      disabled = false,
      multiple: _multiple = false,
      onRemove,
      onClick,
    },
    ref
  ) {
  // _multiple 保留用于未来单选/多选模式的差异化展示
  const displayCount = 3 // 最多显示3个标签

  return (
    <Button
      ref={ref}
      type="button"
      variant="outline"
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'h-auto min-h-10 w-full justify-between font-normal',
        selected.length === 0 && 'text-muted-foreground'
      )}
    >
      <div className="flex flex-wrap gap-1 flex-1">
        {selected.length === 0 ? (
          <span>{placeholder}</span>
        ) : (
          <>
            {selected.slice(0, displayCount).map(user => (
              <Badge
                key={user.id}
                variant="secondary"
                className="gap-1 pr-1"
                onClick={(e) => {
                  e.stopPropagation()
                  onRemove?.(user.id)
                }}
              >
                {user.nickname}
                <X className="h-3 w-3 cursor-pointer" />
              </Badge>
            ))}
            {selected.length > displayCount && (
              <Badge variant="secondary">
                +{selected.length - displayCount} 更多
              </Badge>
            )}
          </>
        )}
      </div>
      <ChevronDown className="h-4 w-4 shrink-0 opacity-50 ml-2" />
    </Button>
  )
  }
)
